/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
import {NgModule} from '@angular/core';
import {MyRequiredFileValidatorDirective} from './required-file-validator.directive';

@NgModule({
    declarations: [MyRequiredFileValidatorDirective],
    exports: [MyRequiredFileValidatorDirective]
})
export class MyRequiredFileValidatorModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/requiredFile/required-file-validator.module.ts